"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceStyled = exports.PriceItemStyled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _const = require("../../../const");

var _utils = require("../../../utils");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PriceItemStyled = /*#__PURE__*/(0, _styledComponents.default)("span").withConfig({
  displayName: "pricestyled__PriceItemStyled",
  componentId: "h9ixuz-0"
})(["line-height:22px;", " ", "{line-height:16px;}"], function (_ref) {
  var type = _ref.type,
      size = _ref.size,
      $color = _ref.$color;

  switch (type) {
    case 'old':
      return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          color: ", ";\n          font-size: ", ";\n          font-weight: 300;\n          text-decoration: line-through;\n        "])), _const.Colors.gray500, size === 'md' ? '12px' : 'inherit');

    case 'final':
      return (0, _utils.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          color: ", ";\n          font-weight: 700;\n        "])), _const.Colors.primary);

    default:
      return (0, _utils.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          color: ", ";\n        "])), _const.Colors[$color] || _const.Colors.gray800);
  }
}, _const.GridBreakpointsMediaDown.md);
exports.PriceItemStyled = PriceItemStyled;
var PriceStyled = /*#__PURE__*/(0, _styledComponents.default)("div").withConfig({
  displayName: "pricestyled__PriceStyled",
  componentId: "h9ixuz-1"
})(["font-size:", ";display:inline-block;", "{&:not(:last-of-type){margin-right:10px;}}"], function (_ref2) {
  var measure = _ref2.measure;
  return measure === 'lg' ? '24px' : '14px';
}, PriceItemStyled);
exports.PriceStyled = PriceStyled;